import { __assign } from "tslib";
import React from 'react';
import { ComponentErrorBoundary } from '../ComponentErrorBoundary';
import { LazyFeature } from './LazyFeature';
/**
 * Shared component error boundary
 * @param options for componentName and disabled
 * @returns a common error boundary for components
 *
 * @todo: Pass in props to support ErrorBoundaryProps and custom fallbacks
 */
export var LazyComponentErrorBoundary = function (_a) {
    var children = _a.children, componentName = _a.componentName, _b = _a.lazyFeatureProps, lazyFeatureProps = _b === void 0 ? {} : _b, onError = _a.onError;
    return (React.createElement(ComponentErrorBoundary, { componentName: componentName, onError: onError },
        React.createElement(LazyFeature, __assign({}, lazyFeatureProps), children)));
};
//# sourceMappingURL=LazyComponentErrorBoundary.js.map